"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _utils = require("@trs/utils");
var _general = require("@trs/utils/lib/general");
var _Input = _interopRequireDefault(require("./Input.style"));
var _TooltipError = _interopRequireDefault(require("./TooltipError"));
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var INPUT_MAX_LENGTH = _config["default"].INPUT_MAX_LENGTH;
var DEFAULT_INPUT_WIDTH = '100%';
var handleOnChange = function handleOnChange(event, type, isInputFocused) {
  var newEvent = event;
  if (type === 'number') {
    var regex = /^-?[0-9]*\.?[0-9]*/;
    var value = event.target.value;
    value = isInputFocused ? value : (0, _general.removeNumberFormatting)(value);
    var m = regex.exec(value);
    value = m && m[0] ? m[0] : '';
    newEvent.target.value = value;
  }
  return newEvent;
};
var formatValue = function formatValue(value, type, isNumber, isInputFocused, withLocaleFormatNumber) {
  if (!value || !withLocaleFormatNumber || isInputFocused || !isNumber) return value;
  return type === 'percentage' ? (0, _general.formatNumber)(value).concat('%') : (0, _general.formatNumber)(value);
};
var Input = function Input(_ref) {
  var onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    onChange = _ref.onChange,
    onKeyUp = _ref.onKeyUp,
    isDisabled = _ref.isDisabled,
    placeholder = _ref.placeholder,
    type = _ref.type,
    value = _ref.value,
    maxLength = _ref.maxLength,
    error = _ref.error,
    required = _ref.required,
    supportNegative = _ref.supportNegative,
    id = _ref.id,
    width = _ref.width,
    children = _ref.children,
    name = _ref.name,
    ariaLabel = _ref.ariaLabel,
    submitIconAriaLabel = _ref.submitIconAriaLabel,
    requiredFieldLabel = _ref.requiredFieldLabel,
    negativeValueLabel = _ref.negativeValueLabel,
    icon = _ref.icon,
    iconClick = _ref.iconClick,
    variant = _ref.variant,
    isFocused = _ref.isFocused,
    withLocaleFormatNumber = _ref.withLocaleFormatNumber,
    className = _ref.className,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps;
  var _useState = (0, _react.useState)(isFocused),
    _useState2 = _slicedToArray(_useState, 2),
    isInputFocused = _useState2[0],
    setIsInputFocused = _useState2[1];
  var handleOnFocus = function handleOnFocus(ev) {
    setIsInputFocused(true);
    ev.stopPropagation();
    onFocus && onFocus(ev);
  };
  var handleOnBlur = function handleOnBlur(ev) {
    setIsInputFocused(false);
    ev.stopPropagation();
    onBlur && onBlur(ev);
  };
  var isNumber = type === 'number' || type === 'percentage';
  var hasError = !(0, _utils.isBlank)(error);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    className: "input-wrapper ".concat(className),
    hasError: hasError,
    isDisabled: isDisabled,
    isRequired: required && (0, _utils.isBlank)(value),
    width: width,
    icon: icon,
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    id: id,
    name: name,
    onBlur: handleOnBlur,
    onChange: R.compose(onChange, function (ev) {
      return handleOnChange(ev, type, isInputFocused);
    })
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: isFocused,
    onFocus: handleOnFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    disabled: isDisabled,
    placeholder: placeholder,
    "aria-label": ariaLabel || placeholder,
    type: isNumber ? undefined : type,
    value: formatValue(value, type, isNumber, isInputFocused, withLocaleFormatNumber),
    maxLength: maxLength,
    autoComplete: "off",
    required: required
  }, inputProps)), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "input-icon",
    icon: icon,
    "aria-label": submitIconAriaLabel || 'Submit input content',
    onClick: function onClick() {
      iconClick('submit');
    }
  }), hasError && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: error,
    id: "".concat(id, "Error")
  }), required && (0, _utils.isBlank)(value) && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: requiredFieldLabel || 'This is a mandatory field',
    id: "".concat(id, "RequiredError")
  }), !supportNegative && (0, _utils.isNegative)(value) && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: negativeValueLabel || 'Negative values are not supported',
    id: "".concat(id, "RequiredError")
  }), children);
};
Input.defaultProps = {
  name: '',
  error: undefined,
  placeholder: '',
  value: '',
  type: 'text',
  isDisabled: false,
  inputProps: {},
  maxLength: INPUT_MAX_LENGTH,
  onKeyUp: undefined,
  onKeyDown: undefined,
  onFocus: undefined,
  onChange: undefined,
  onBlur: undefined,
  required: false,
  supportNegative: true,
  width: DEFAULT_INPUT_WIDTH,
  children: null,
  ariaLabel: '',
  submitIconAriaLabel: '',
  requiredFieldLabel: '',
  negativeValueLabel: '',
  icon: '',
  iconClick: function iconClick() {},
  variant: 'outlined',
  isFocused: false,
  withLocaleFormatNumber: false,
  className: ''
};
Input.propTypes = {
  name: _propTypes["default"].string,
  children: _propTypes["default"].node,
  id: _propTypes["default"].string.isRequired,
  isDisabled: _propTypes["default"].bool,
  inputProps: _propTypes["default"].shape({}),
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  type: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),
  required: _propTypes["default"].bool,
  supportNegative: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  width: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  submitIconAriaLabel: _propTypes["default"].string,
  requiredFieldLabel: _propTypes["default"].string,
  negativeValueLabel: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  iconClick: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  withLocaleFormatNumber: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Input);